module.exports = __webpack_public_path__ + "media/a2.dd26fbea.mp3";